export default "__VITE_ASSET__B78GP8iu__"